import { fetchFastApi } from "./fastapi";
import {
  FyCycleOption,
  FyCycleOptionSchema,
} from "../models/audit/fyCycleOption";
import { z } from "zod";

export async function getFyCycleOptions(): Promise<FyCycleOption[]> {
  const response = await fetchFastApi({
    method: "GET",
    path: "/controls/v2/fy-cycle-options",
  });
  return z.array(FyCycleOptionSchema).parse(response.fyCycleOptions);
}

export async function createFyCycleOption(
  name: string,
  isDefault: boolean = false,
): Promise<FyCycleOption> {
  const response = await fetchFastApi({
    method: "POST",
    path: "/controls/v2/fy-cycle-options",
    body: { name, is_default: isDefault },
  });
  return FyCycleOptionSchema.parse(response.fyCycleOption);
}

export async function setDefaultFyCycleOption(id: string): Promise<void> {
  await fetchFastApi({
    method: "PATCH",
    path: `/controls/v2/fy-cycle-options/${id}/set-default`,
  });
}
